import { render } from "./BayerChart.vue?vue&type=template&id=70ed32a6&scoped=true"
import script from "./BayerChart.vue?vue&type=script&lang=js"
export * from "./BayerChart.vue?vue&type=script&lang=js"

import "./BayerChart.vue?vue&type=style&index=0&id=70ed32a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ed32a6"]])

export default __exports__